module.exports = __webpack_public_path__ + "static/media/Manny.f9c15ece.jpg";